import React, { useEffect } from "react";
import { Table, Tooltip, Image } from "antd";
import { ColumnsType } from "antd/es/table";
import { useCardModel } from "../cardModel";
import { ICardDetail } from "../cardService";
import { getBaseRequestUrl, getToken, getFileUrl } from "@/utils/constants";
import { useDictModel } from "@/views/base/dict/dictModel";

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys, setReviewVisible
    } = useCardModel();
    const { getTreeNodeName } = useDictModel(() => []);
    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<ICardDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '员工姓名',
            width: 120,
            dataIndex: 'name',
            fixed: "left",
        }, {
            title: '电话',
            width: 140,
            dataIndex: 'phone',
            fixed: "left",
        }, {
            title: '电话1',
            width: 120,
            dataIndex: 'phone1',
        }, {
            title: '微信号',
            width: 120,
            dataIndex: 'wechat',
        },{
            title: '管理公司',
            width: 140,
            dataIndex: 'orgName',
        },  {
            title: '部门',
            width: 140,
            dataIndex: 'depName',
        }, {
            title: '职位',
            width: 120,
            dataIndex: 'position',
        }, {
            title: '邮箱',
            width: 120,
            dataIndex: 'email',
        }, {
            title: '公司',
            width: 160,
            dataIndex: 'company',
        }, {
            title: '地址',
            width: 180,
            dataIndex: 'address',
            render: text => <Tooltip placement="topLeft" title={text} arrowPointAtCenter><p className="ellipsis">{text}</p></Tooltip>,
        }, {
            title: '公司名称',
            width: 160,
            dataIndex: 'ebcCompanyDto',
            render: (detail) => detail?.name ?? ""
        }, {
            title: '业务名称',
            width: 160,
            dataIndex: 'ebcBusinessDto',
            render: (detail) => detail?.name ?? ""
        }, {
            title: '二维码',
            width: 80,
            dataIndex: 'ebcBusinessDto',
            className: "p-0",
            render: (detail) => detail?.qrCode ? <Image src={getFileUrl(detail.qrCode)} style={{ width: "40px", height: "40px", marginRight: "10px" }} /> : ""
        }, {
            title: '名片属性',
            width: 160,
            dataIndex: 'cardType',
            render: text => getTreeNodeName(text),
        }, {
            title: '名片状态',
            width: 100,
            dataIndex: 'status',
            render: text => text == "1" ? "启用" : "禁用"
        }, {
            title: '操作',
            width: 60,
            fixed: "right",
            render: (text, record) => <span
                style={{ color: "#6c72f3", cursor: "pointer" }}
                onClick={(e) => {
                    e.stopPropagation()
                    setReviewVisible({ visible: true, rowDetail: record })
                }}
            >预览</span>,
        }
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id ?? ""}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId] as string[])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id ?? ""),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id ?? ""),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id ?? ""]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}